export default "__VITE_ASSET__3PHB8GjY__"